/** Number of pages to display in pagination at once. Used in document controller */
const pagesPerGroup = 10; // eslint-disable-line no-unused-vars
const AjaxResultController = {
    $references: null,
    $languageSelector: null,
    $countrySelector: null,
    $searchButton: null,
    $searchErrorMessageFields: null,
    $defaultLangOption: null,
    regulatoryGroupsMapping: null,
    languagesMatrix: null
};

$(document).ready(function () {
    Object.assign(AjaxResultController, {
        $references: $('#references'),
        $languageSelector: $('#language'),
        $countrySelector: $('#country'),
        $searchButton: $('#mi-corpo-sds-search-button'),
        $searchErrorMessageFields: $('#searchErrorMessageFields'),
        $defaultLangOption: $('#defaultLanguageOption')
    });

    //UI events
    $(window).on('resize', function () {
        resizeSdsBox();
    });

    AjaxResultController.$searchButton.on('click', function () {
        const country = AjaxResultController.$countrySelector.val();
        const language = AjaxResultController.$languageSelector.val();

        if (!country || !language) {
            AjaxResultController.$searchErrorMessageFields.removeClass('visually-hidden');
        }
        else {
            AjaxResultController.$searchErrorMessageFields.addClass('visually-hidden');
            $('#mi-corpo-elcaSafetyDataSheet-loading-img').css('display', 'block');
            showResults();
        }
    });

    AjaxResultController.$references.add(AjaxResultController.$countrySelector).add(AjaxResultController.$languageSelector).on('change', function () {
        const url = generateQueryParameters();
        window.history.pushState({}, '', url);
    });

    AjaxResultController.$references.on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            AjaxResultController.$searchButton.click();
        }
    });

    AjaxResultController.$countrySelector.on('change', function () {
        if ($(this).val() === '') {
            AjaxResultController.$languageSelector.attr('disabled', 'disabled');
            AjaxResultController.$languageSelector.empty().append(AjaxResultController.$defaultLangOption);
        }
 else {
            AjaxResultController.$languageSelector.removeAttr('disabled');
            setLanguageOptions();
        }

        AjaxResultController.$languageSelector.val('');
        AjaxResultController.$languageSelector.trigger('change');
    });

    applyURLQueryParameters();
});

function showResults() {
    $('input[name*=\'reseller\']').remove().trigger('change');

    let queryParameters;
    queryParameters = addToUrl(queryParameters, 'reference', AjaxResultController.$references.val());
    queryParameters = addToUrl(queryParameters, 'countryCode', AjaxResultController.$countrySelector.val());
    queryParameters = addToUrl(
        queryParameters,
        'countryName',
        AjaxResultController.$countrySelector[0].options[AjaxResultController.$countrySelector.prop('selectedIndex')].text
    );
    queryParameters = addToUrl(queryParameters, 'lang', AjaxResultController.$languageSelector.val());

    resizeSdsBox();
    renderAsyncRequest('/sds/search', queryParameters, '#mi-corpo-sds-display-results');
}

function resizeSdsBox() {
    const sdsDetailModalHtml = $('.mi-corpo-sds-detail-modal').html();

    if ($('.mi-corpo-sds-results').html().length > 0 && sdsDetailModalHtml && sdsDetailModalHtml.length <= 0) {
        $('.mi-corpo-safety-data-sheets').height($(window).width() >= 992 ? 540 : 800);
    }
}

function renderAsyncRequest(url, queryParameters, domElementToChange, language = 'en') {
    $.ajax({
        url: url + queryParameters,
        dataType: 'html',
        data: { language: language },
        success: function (data) {
            if (domElementToChange != null) { // eslint-disable-line eqeqeq
                $(domElementToChange).html(data);
            }
        }
    });
}

function applyURLQueryParameters() {
    let reference = getParameterByName('reference');
    if (reference) {
        reference = reference.toUpperCase();
        AjaxResultController.$references.val(reference);
    }

    let country = getParameterByName('countryCode');
    if (country) {
        country = country.toUpperCase();
        AjaxResultController.$countrySelector.val(country);

        // Find languages and populate dropdown
        setLanguageOptions();

        let language = getParameterByName('language');
        if (language) {
            language = language.toUpperCase();
            AjaxResultController.$languageSelector.val(language);
        }
    }

    if (reference || country) {
        showResults();
    }
}

function getParameterByName(name) {
    name = name.replace(/[\[]/, '\[').replace(/[\]]/, '\]');
    const regex = new RegExp('[\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);

    return results !== null
        ? decodeURIComponent(results[1].replace(/\+/g, ' '))
        : '';
}

function generateQueryParameters() {
    let queryParameters;
    queryParameters = addToUrl(queryParameters, 'reference', AjaxResultController.$references.val());
    queryParameters = addToUrl(queryParameters, 'countryCode', AjaxResultController.$countrySelector.val());
    queryParameters = addToUrl(queryParameters, 'language', AjaxResultController.$languageSelector.val());

    return location.protocol + '//' + location.host + location.pathname + queryParameters;
}

function addToUrl(url, parameterName, parameterValue) {
    if (url == undefined) {
        url = '';
    }

    return parameterValue
        ? (url ? url + '&' : '?') + parameterName + '=' + parameterValue
        : url;
}

function getRegulatoryGroupsMapping() {
    if (!AjaxResultController.regulatoryGroupsMapping) {
        AjaxResultController.regulatoryGroupsMapping = JSON.parse(
            document.getElementById('regulatory-groups-mapping').textContent
        );
    }

    return AjaxResultController.regulatoryGroupsMapping;
}

function getLanguagesMatrix() {
    if (!AjaxResultController.languagesMatrix) {
        AjaxResultController.languagesMatrix = JSON.parse(
            document.getElementById('languages-matrix').textContent
        );
    }

    return AjaxResultController.languagesMatrix;
}

function setLanguageOptions() {
    const $selectedOption = AjaxResultController.$countrySelector.find('option:selected');

    if ($selectedOption.length === 0) {
        return;
    }

    AjaxResultController.$languageSelector.prop('disabled', false);
    const regulatoryGroup = $selectedOption.data('regulatory');

    // Clear existing options except the empty option
    AjaxResultController.$languageSelector.empty().append(AjaxResultController.$defaultLangOption);

    if (regulatoryGroup && regulatoryGroup.trim() !== '') {
        const allowedLanguages = getRegulatoryGroupsMapping()[regulatoryGroup];
        const langObjects = getLanguagesMatrix().filter(x => allowedLanguages.includes(x[0]));

        langObjects.forEach(language => {
            AjaxResultController.$languageSelector.append(
                $('<option>', {
                    value: language[0],
                    text: language[1]
                })
            );
        });
    }
}
